/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import * as Papa from 'papaparse';
import readXlsxFile from 'read-excel-file';

class Imports implements MerchantosImports {
  typeMap: MerchantosImports['typeMap'];

  delimiter: MerchantosImports['delimiter'];

  matchFields: MerchantosImports['matchFields'];

  matchColumnValues: MerchantosImports['matchColumnValues'];

  constructor() {
    this.typeMap = {
      Item: 'items',
      Order: 'purchase',
      Image: 'image',
    };

    // Default to comma-separated CSV files, but the CSV Parser can override when
    // setting up the preview
    this.delimiter = ',';
    this.matchFields = ['System ID', 'UPC', 'EAN', 'Custom SKU', 'Manufacturer SKU', 'Vendor ID'];
    // Corresponding API values to matchFields array
    this.matchColumnValues = [
      'systemSku',
      'upc',
      'ean',
      'customSku',
      'manufacturerSku',
      'ItemVendorNums.value',
    ];
  }

  /**
   * Kicks off the import for items/orders/images
   * @param  field      The file input field
   * @param  type       The parent endpoint name (Item, Image, Order)
   * @param  optionalID The parent obj id if one exists (Order only atm)
   */
  // @ts-expect-error ts-migrate(2416) FIXME: Property 'import' in type 'Imports' is not assigna... Remove this comment to see the full error message
  import = (field: HTMLInputElement, type: string, optionalID: string) => {
    window.hideNotifier('warning');

    const xhr = new XMLHttpRequest();
    const formData = new FormData();

    // Set the metadata
    const data = window.merchantos.imports.getMetaData(type);
    formData.append('data', data);

    // Add the files to the request
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < field.files.length; index++) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      formData.append(type + index, field.files[index]);
    }

    const url = window.merchantos.imports.getImportUrl(type, optionalID);

    xhr.open('POST', url);

    xhr.setRequestHeader('Accept', 'application/xml');
    xhr.setRequestHeader('Cache-Control', 'no-cache');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onload = () => {
      const xml_doc = $.parseXML(xhr.responseText);
      const xml_doc_error = xml_doc.querySelector('Error > message');

      // catch any exceptions throw by API call
      if (xml_doc_error) {
        // trim out filename and linenumber to make
        // message more readable
        const err_message = xml_doc_error.innerHTML.split(' (')[0];
        window.showNotifier('warning', err_message, 10);
        $('.import-status').hide();
      }
      // eslint-disable-next-line default-case
      switch (type) {
        // eslint-disable-next-line no-fallthrough
        case 'Order':
        case 'Item':
        case 'Image':
          window.merchantos.items.importStart(xml_doc);
          break;
      }
    };

    xhr.onloadstart = () => {
      // eslint-disable-next-line default-case
      switch (type) {
        // eslint-disable-next-line no-fallthrough
        case 'Order':
        case 'Item':
        case 'Image':
          window.merchantos.items.uploadStart();
          break;
      }
    };

    xhr.send(formData);
  };

  importClearInput = () => {
    $('.import-welcome, .import-email-address, #recent_import_listing_view').show();

    const file_input = $('#product-import>input, #import-object>input').eq(0);

    const wrap_form = file_input.wrap('<form>').closest('form').get(0) as HTMLFormElement;
    // File input values cannot be modified by js for user security, so in order
    // to empty it, wrap it in a form and reset the form
    if (wrap_form) {
      wrap_form.reset();
    }
    // Then take the input back out of the form.
    file_input.unwrap();
  };

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'importShowWarning' in type 'Imports' is ... Remove this comment to see the full error message
  // eslint-disable-next-line consistent-return
  importShowWarning = (uploadField: HTMLInputElement, type: string, optionalID: string) => {
    $('.import-welcome, #recent_import_listing_view').hide();
    const import_class = window.merchantos.imports.getImportCSSClass(type);
    const confirm_elements = $(`.confirm-import${import_class}`);
    confirm_elements.show();

    const turn_off_preview_links = () => {
      $('.cancel-import').off('click');
      confirm_elements.find('button').off('click');
    };

    confirm_elements.find('button').on('click', () => {
      if (type !== 'Image') {
        if (window.merchantos.imports.validatePreview()) {
          turn_off_preview_links();
          window.merchantos.imports.import(uploadField, type, optionalID);
        } else {
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        }
      } else {
        turn_off_preview_links();
        // Different import process for cloudinary
        window.merchantos.images.import(uploadField);
      }
    });
    // No need to preview an image upload
    if (type !== 'Image') {
      window.merchantos.imports.loadPreview(uploadField, type);
    } else {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      const file_count = uploadField.files.length;
      if (file_count <= 1000) {
        window.merchantos.images.showFileInfo(file_count);
      } else {
        let msg = 'Number of images selected exceeds the 1,000 images ';
        msg += 'per upload limit';
        $('.import-status').show();
        // Re-hide these because there's a problem with the files selected
        // and the user needs to fix it before attempting to continue
        confirm_elements.hide();
        return window.merchantos.images.showUploadError([msg]);
      }
    }

    $('.cancel-import').on('click', (event) => {
      event.preventDefault();
      turn_off_preview_links();
      confirm_elements.hide();
      $('p.validation-failure').hide();
      $('.import-status').hide();
      window.merchantos.imports.importClearInput();
    });
  };

  incrementProgress = (total: number, progress: number) => {
    $('#progressPercentage').text(Math.floor((progress / total) * 100));
  };

  loadPreview = (uploadField: HTMLInputElement, type: string) => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    const file = uploadField.files.item(0);

    if (!file) {
      return;
    }

    window.merchantos.imports.showFileInfo(file.name);
    if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.previewXLSXFile(file, type);
    } else {
      this.previewCSVFile(file, type);
    }
  };

  private previewCSVFile(file: any, type: string) {
    let line_count = 0;
    let preview_shown = false;
    const first_lines: TSFixMe = [];
    const preview = $('.import-preview');
    window.merchantos.imports.fillPreviewLines(preview, [['']]);
    Papa.parse(file, {
      // The step function streams the CSV lines rather than store them in memory
      step: (results) => {
        if (!preview_shown) {
          // Get and set the delimiter early
          this.delimiter = results.meta.delimiter;
          // results.data is an array containing only one row
          if (first_lines.length < 2) {
            first_lines[first_lines.length] = results.data;
          }
          if (first_lines.length === 2) {
            const preview = $('.import-preview');
            window.merchantos.imports.fillPreviewLines(preview, first_lines);
            preview.show();
            preview_shown = true;
          }
        }
        line_count += 1;
      },
      // At the end of the file, display the line count
      complete() {
        const validator = $('#line-validator');
        if (validator && validator.length > 0) {
          validator.attr('line_count', line_count);
          validator.attr('import_type', type);
        }

        const lines_note = $('<p>').addClass('import-line-count');
        lines_note.text(`${line_count} lines`);

        $('.import-status').find('div').append(lines_note);
      },
      error() {}, // TODO: handle errors?
      skipEmptyLines: true,
    });
  }

  private previewXLSXFile(file: any, type: string) {
    const reader = new FileReader();
    reader.onload = async (event) => {
      const preview = $('.import-preview');

      if (!event.target || !event.target.result) {
        const error = 'The preview failed to load the file.';
        window.alertUser(error);
        window.merchantos.imports.fillPreviewLines(preview, [['']]);
        return false;
      }

      const data = new Uint8Array(event.target.result as ArrayBuffer);
      const $rows = await readXlsxFile(data);
      if ($rows.length < 2) {
        const error = 'The preview requires at least 2 non-empty lines in the file.';
        window.alertUser(error);
        window.merchantos.imports.fillPreviewLines(preview, [['']]);
        return false;
      }

      // Preview only the first two lines
      const slicedLines = 2;
      const firstLines: string[][] = $rows
        .slice(0, slicedLines)
        .map((line) => line.map((field) => String(field ?? '')));

      window.merchantos.imports.fillPreviewLines(preview, firstLines);
      preview.show();

      const validator = $('#line-validator');
      if (validator && validator.length > 0) {
        validator.attr('line_count', $rows.length);
        validator.attr('import_type', type);
      }
      const lines_note = $('<p>').addClass('import-line-count');
      lines_note.text(`${$rows.length} lines`);

      $('.import-status').find('div').append(lines_note);
    };
    reader.readAsArrayBuffer(file);
  }

  showFileInfo = (file_name: string) => {
    const status_box = $('.import-status');
    const status_div = status_box.find('div');

    status_div.empty();
    status_div.append(window.merchantos.imports.getCancelButton());

    const head = $('<h2>');
    head.text(file_name);

    status_div.append(head);

    status_box.addClass('summary');
    status_box.show();
  };

  validatePreview = () => {
    const validation_elements = $('p.validation-failure');
    // 1. Hide previous messages
    validation_elements.hide();
    // 2. Look at each validation element and check appropriately
    let passed = true;
    validation_elements.each((_i, element) => {
      const validation_fnc = $(element).attr('validator');
      let funct = window;
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      // eslint-disable-next-line no-return-assign
      $.each(validation_fnc.split('.'), (_j, name) => (funct = funct[name]));

      // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
      const result = funct(element);
      // If the function returned false, remember
      passed = result ? passed : result;
    });
    // Return the result
    return passed;
  };

  // Validators
  dependentFieldValidator = (failure_elem: JQuery<HTMLElement>) => {
    // eslint-disable-next-line no-param-reassign
    failure_elem = $(failure_elem);
    // 1. Get the selected options
    const selects = failure_elem.parent().find('select.header-select');
    // 2. Iterate through them to find the required columns
    const selected = {};
    const required = {};
    selects.each((_i, select) => {
      const sel = $(select);
      const option = sel.find('option:selected');
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      selected[sel.val() as string] = true;
      if (option.attr('import-depend-column')) {
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
        required[option.attr('import-depend-column')] = option.text();
      }
    });
    // 3. Check whether the required columns have been selected
    const err_msg: TSFixMe = [];
    // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
    $.each(_.keys(required), (_i, key) => {
      if (key in selected) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        delete required[key];
      } else {
        err_msg[err_msg.length] = `${selects
          .first()
          .find(`option[value="${key}"]`)
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          .text()}" which is required by the field "${required[key]}"`;
      }
    });
    // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
    if (_.size(required)) {
      let error = 'You have not selected the field "';
      error += `${err_msg.join(' or "')}.`;
      failure_elem.text(error);
      failure_elem.show();
      return false;
    }
    return true;
  };

  duplicateFieldValidator = (failure_elem: JQuery<HTMLElement>) => {
    // eslint-disable-next-line no-param-reassign
    failure_elem = $(failure_elem);
    // 1. Get the selected options
    const selects = failure_elem.parent().find('select.header-select');
    const options = selects.find('option:selected');
    // 2. Iterate through, checking whether multiple are allowed
    const existing = {};
    const duplicates = {};
    options.each((_i, opt) => {
      const option = $(opt);
      if ((option.val() as string) in existing) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        duplicates[option.text()] = true;
      } else if (!option.attr('import-allow-multiple')) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        existing[option.val() as string] = true;
      }
    });
    // 3. Report the not allowed dupes
    // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
    if (_.keys(duplicates).length) {
      let error = 'You have the same field';
      // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
      error += _.keys(duplicates).length === 1 ? ' "' : 's "';
      // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
      error += `${_.keys(duplicates).join('", "')}" more than once.`;
      failure_elem.text(error);
      failure_elem.show();
      return false;
    }
    return true;
  };

  emailValidator = (failure_elem: JQuery<HTMLElement>) => {
    // eslint-disable-next-line no-param-reassign
    failure_elem = $(failure_elem);
    const email_input = failure_elem.siblings('input#employee_email');
    const email = email_input.val() as string;
    if (email.length > 0 && !window.isEmail(email)) {
      failure_elem.show();
      return false;
    }
    return true;
  };

  lineCountValidator = (failure_elem: JQuery<HTMLElement>) => {
    // eslint-disable-next-line no-param-reassign
    failure_elem = $(failure_elem);
    let type = failure_elem.attr('import_type');
    // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
    type = window.merchantos.imports.typeMap[type];
    const lines = failure_elem.attr('line_count');
    // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
    const max_lines = window.merchantos[type].maxCSVRowCount;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (lines > max_lines) {
      const msg = `Your file is too large, the maximum row count for import is ${max_lines} rows.`;
      failure_elem.text(msg);
      failure_elem.show();
      return false;
    }
    return true;
  };

  requiredFieldValidator = (failure_elem: JQuery<HTMLElement>) => {
    // eslint-disable-next-line no-param-reassign
    failure_elem = $(failure_elem);
    const required_fields = {};
    const selects = failure_elem.parent().find('select');
    // Find all the options that have the 'import-required' attribute
    const req_options = selects.first().children('option[import-required="true"]');
    const sel_req_options = selects.children('option[import-required="true"]:selected');
    req_options.each((_i, option) => {
      // @ts-expect-error ts-migrate(2740) FIXME: Type 'JQuery<HTMLElement>' is missing the followin... Remove this comment to see the full error message
      // eslint-disable-next-line no-param-reassign
      option = $(option);
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      required_fields[option.val() as string] = option.text();
    });
    // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
    let passed = !_.size(required_fields);
    // Check all the selected required options to see if the set is complete
    // eslint-disable-next-line consistent-return
    sel_req_options.each((_i, option) => {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'JQuery<HTMLElement>' is not assignable to ty... Remove this comment to see the full error message
      // eslint-disable-next-line no-param-reassign
      option = $(option);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'val' does not exist on type 'HTMLElement... Remove this comment to see the full error message
      const val = option.val();
      if (val in required_fields) {
        // If a required option has been selected, quit looking for it
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        delete required_fields[val];
        // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
        passed = !_.size(required_fields);
      }
      if (passed) {
        // Break the each loop
        return false;
      }
    });
    if (!passed) {
      // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
      const plural = _.size(required_fields) > 1;
      let error = 'You have not selected the field';
      error += plural ? 's "' : ' "';
      const fields: TSFixMe = [];
      // @ts-expect-error ts-migrate(2686) FIXME: '_' refers to a UMD global, but the current file i... Remove this comment to see the full error message
      // eslint-disable-next-line no-return-assign
      $.each(_.keys(required_fields), (_i, key) => (fields[fields.length] = required_fields[key]));
      error += `${fields.join('", "')}" which `;
      error += plural ? 'are' : 'is';
      error += ' required for import';
      failure_elem.text(error);
      failure_elem.show();
    }
    return passed;
  };

  shopSelectValidator = (failure_elem: JQuery<HTMLElement>) => {
    // eslint-disable-next-line no-param-reassign
    failure_elem = $(failure_elem);
    const shop_select = failure_elem.siblings('select#shop_select');
    const multi_shop = failure_elem.siblings('label').find('input[type=checkbox]');
    if (!shop_select.val() && !multi_shop.is(':checked')) {
      failure_elem.show();
      return false;
    }
    return true;
  };

  itemImportOptionsValidator = (failure_elem: JQuery<HTMLElement>) => {
    // eslint-disable-next-line no-param-reassign
    failure_elem = $(failure_elem);
    const create = failure_elem.siblings('label').find('input[name="new"]');
    const modify = failure_elem.siblings('label').find('input[name="update_existing"]');

    if (!(create.is(':checked') || modify.is(':checked'))) {
      failure_elem.show();
      return false;
    }
    failure_elem.hide();
    return true;
  };

  // Helpers

  fillPreviewLines = (preview_elem: JQuery<HTMLElement>, lines: string[][]) => {
    const old_body = preview_elem.find('tbody');
    const old_tr = $(old_body.find('tr')[0]);
    const headers = lines.shift();
    const matchRows: TSFixMe = [];
    const matchRowNames: TSFixMe = [];

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string[] | undefined' is not ass... Remove this comment to see the full error message
    const new_body = this.getNewPreviewTable(headers, old_tr);
    // 2. Remove the old table body
    old_body.remove();
    // 3. Add data from lines
    const new_rows = new_body.find('tr');
    // Should always be 1, the preview length
    const num_lines = lines.length;

    const add_line_to_new_rows = (k: TSFixMe, data: TSFixMe) => {
      const rowName = $($(new_rows[k]).find('td strong')[0]).html();
      const matchOn = $($(new_rows[k]).find('td')[3]).children();

      // Only add if there is content in the cell
      if (data?.length) {
        const data_cell = $($(new_rows[k]).find('td')[2]);
        if (data_cell.text().length) {
          data_cell.append(`, ${data}`);
        } else {
          data_cell.append(data);
        }
      }

      // Show radio button for fields specified in matchFields
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
      if (window.merchantos.imports.matchFields.indexOf(rowName) >= 0) {
        matchOn.show();
        matchRows.push(matchOn);
        matchRowNames.push(rowName);
      } else {
        matchOn.hide();
      }
    };

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < num_lines; i++) {
      const line = lines[i];
      $.each(line, add_line_to_new_rows);
    }

    preview_elem.find('table').append(new_body);
    // TODO: check for errors?

    const updateExisting = $("input[name='update_existing']").is(':checked');
    const systemIdRow = $("strong:contains('System ID')").closest('tr');
    const createNew = $("input[name='new']").is(':checked');
    const systemIdOption = $(".header-select option[value='systemSku']");

    // Hide match on column if update existing is not checked
    if (!updateExisting) {
      $('.match_on').hide();

      // Hide System ID row if create new is checked
      if (createNew) {
        systemIdOption.hide();
        systemIdRow.hide();
      }
      // Show System ID row if modify is checked
      else {
        systemIdRow.show();
      }
    } else {
      systemIdOption.show();
      $('.match_on').show();
    }

    // Sets default match on row based on order of matchFields array
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < window.merchantos.imports.matchFields.length; i++) {
      const currentMatch = window.merchantos.imports.matchFields[i];
      if (matchRowNames.indexOf(currentMatch) >= 0) {
        matchRows[matchRowNames.indexOf(currentMatch)].prop('checked', true);
        break;
      }
    }
  };

  getCancelButton = () => {
    const button = $('<button>').addClass('cancel-import');
    button.text('Cancel & Discard');
    return button;
  };

  getImportCSSClass = (type: string) => `.${type.toLowerCase()}-import`;

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'getLineDelim' in type 'Imports' is not a... Remove this comment to see the full error message
  getLineDelim = (input: string) => {
    let delim;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < input.length; i++) {
      if (delim) {
        break;
      }
      if (input.charAt(i) === '\r') {
        delim = '\r';
        if (input.charAt(i + 1) === '\n') {
          delim += '\n';
        }
      } else if (input.charAt(i) === '\n') {
        delim = '\n';
        if (input.charAt(i + 1) === '\r') {
          delim += '\r';
        }
      }
    }
    return delim;
  };

  getNewPreviewTable = (headers: string[], old_tr: JQuery<HTMLElement>) => {
    old_tr.show();
    // Remove old data from the old_tr that gets cloned
    old_tr.find('option').removeAttr('selected');
    $(old_tr.find('td')[2]).empty();
    const new_body = $('<tbody>');
    // Create a row per column
    $.each(headers, (_i, header) => {
      const tr = old_tr.clone();
      // Set the column name and select box
      const cols = tr.find('td');
      const matches = cols.find('option').filter(function onFilterOptions() {
        return $(this).text().toLowerCase() === header.trim().toLowerCase();
      });
      if (matches.length > 0) {
        matches.first().attr('selected', 1);
      }
      $(cols[0]).find('strong').text(header);
      new_body.append(tr);
    });
    return new_body;
  };

  getMetaData = (type: string) => {
    let data = '<?xml version="1.0"?>';
    data += '<ImportData>';
    if (type !== 'Image') {
      data += '<ignoreFirstLine>true</ignoreFirstLine><colDelim>,</colDelim>';
      if ($('input[name="update_existing"]').is(':checked')) {
        data += '<updateExisting>true</updateExisting>';
      } else {
        data += '<updateExisting>false</updateExisting>';
      }
      if ($('input[name="new"]').is(':checked')) {
        data += '<createNew>true</createNew>';
      } else {
        data += '<createNew>false</createNew>';
      }
      const col_selects = $('.import-preview').find('select.header-select');
      if (col_selects.length) {
        data += '<columnOrder>';
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < col_selects.length - 1; i++) {
          data += `${$(col_selects[i]).val()},`;
        }
        data += $(col_selects[col_selects.length - 1]).val();
        data += '</columnOrder>';
        // If there is a customizable header, then the CSV parser should
        // have detected what it is
        data += '<colDelim>';
        data += window.merchantos.imports.delimiter;
        data += '</colDelim>';
      }
    }

    const matchOn = $('input:radio:checked').closest('tr').find('.column_heading strong').html();

    const matchColumn =
      window.merchantos.imports.matchColumnValues[
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        window.merchantos.imports.matchFields.indexOf(matchOn)
      ];

    if (typeof matchOn !== 'undefined') {
      data += `<matchColumn>${matchColumn}</matchColumn>`;
    }

    if ($('input#employee_email').length) {
      data += `<email>${$('[name="email"]').val()}</email>`;
    }

    data += '</ImportData>';
    return data;
  };

  getImportUrl = (type: string, optionalID: string) => {
    const accountID = window.merchantos.session.getSystemCustomerID();
    let url = `/API/Account/${accountID}/${type}`;
    if (optionalID) {
      url += `/${optionalID}`;
    }
    url += '/Import';
    return url;
  };
}

class Purchase implements MerchantosPurchase {
  maxCSVRowCount: MerchantosPurchase['maxCSVRowCount'];

  constructor() {
    // For PO import we allow no more than 500
    this.maxCSVRowCount = 500;
  }
}

class Items implements MerchantosItems {
  maxCSVRowCount: MerchantosItems['maxCSVRowCount'];

  multiStoreOptions: MerchantosItems['multiStoreOptions'];

  singleStoreOptions: MerchantosItems['singleStoreOptions'];

  constructor() {
    // Hold preview select options rather than hiding them, because setting
    // display=none on an optgroup doesn't work for all browsers
    this.multiStoreOptions = false;
    this.singleStoreOptions = false;
    // For item import, we allow no more than 5,001 lines
    this.maxCSVRowCount = 5001;
  }

  uploadStart = () => {
    $('.import-status').empty();
    let html = '<span class="icon-spinner icon-spin icon-large" style="font-size: 1.5rem;"></span>';
    html +=
      '<span style="text-transform: uppercase; color: #555; font-weight: bold; font-size: 1rem;">';
    html += 'Upload is currently under way</span>';
    html += '<p><span id="progressPercentage" notranslate>0</span>% Complete</p>';
    $('.import-status').append(html);
    $('.confirm-import').hide();
    $('.import-status').show();
  };

  // eslint-disable-next-line consistent-return
  importStart = (response: XMLDocument) => {
    window.merchantos.itemCaching.flushCache();
    const jobID = $(response).find('jobID').text();
    if (jobID.length !== 0) {
      return window.newView('view', 'admin.views.job', jobID);
    }

    window.merchantos.imports.importClearInput();
    $('.import-welcome, #recent_import_listing_view').show();
    $('.import-status').empty();
    // No jobID, something went wrong.
    let message = '<strong class="import-failure-errors">There was an error:</strong><br>';
    message += `<span notranslate>${$(response).find('message').text()}</span>`;
    $('.import-status').append(message);
  };

  multiStoreSelects = () => {
    const single_store = !$('input#multi_store_checkbox').is(':checked');
    $('#shop_select').toggle(single_store);
    if (single_store) {
      // Single shop import
      // Show the 'Inventory' optgroups
      if (window.merchantos.items.singleStoreOptions) {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        $('select.header-select').append(this.singleStoreOptions);
      }
      // Hide the Multishop options
      if (!window.merchantos.items.multiStoreOptions) {
        window.merchantos.items.multiStoreOptions = $('select.header-select')
          .first()
          .children('optgroup.multi-store-options')
          .detach();
      }
      $('optgroup.multi-store-options').remove();
    } else {
      // Multi shop import
      // Hide the 'Inventory' optgroups
      if (!window.merchantos.items.singleStoreOptions) {
        window.merchantos.items.singleStoreOptions = $('optgroup.single-store-options')
          .first()
          .detach();
      }
      $('optgroup.single-store-options').remove();
      // Show the MultiShop options
      if (window.merchantos.items.multiStoreOptions) {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        $('select.header-select').append(this.multiStoreOptions);
      }
    }
  };

  singleStoreSelects = () => {
    const selected = $('#shop_select option:selected');
    // Find its value, which should also be the shop's id
    const id = selected.val();
    // Then find all of the 'Inventory' options
    const options = $('option.single-store-options');
    for (let i = options.length - 1; i >= 0; i--) {
      const option = $(options[i]);
      // Then split the vals by '|'
      const old_val = $(option).val();
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const name = old_val.split('|')[1];
      // And reassign the values with the new id and name
      $(option).val(`${id}|${name}`);
    }
    // Don't forget to hide the multishop options
    const selects = $('select.header-select');
    if (!window.merchantos.items.multiStoreOptions) {
      window.merchantos.items.multiStoreOptions = selects
        .first()
        .children('optgroup.multi-store-options')
        .detach();
    }
    $('optgroup.multi-store-options', selects).remove();
  };
}

class Images implements MerchantosImages {
  // eslint-disable-next-line consistent-return
  import = (field: HTMLInputElement) => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    const file_count = field.files.length;
    let uploaded = 0;
    const url = field.getAttribute('data-url');
    const bad_responses: TSFixMe = [];
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
    const max_size = parseInt(field.getAttribute('max-file-mb'), 10);
    const formData = new FormData();
    $('.image-import.confirm-import').hide();

    // @ts-expect-error ts-migrate(2300) FIXME: Duplicate identifier 'this'.
    // eslint-disable-next-line no-dupe-args
    const process_finished_request = function processFinishedRequest(this: TSFixMe, this: TSFixMe) {
      uploaded += 1;
      window.merchantos.imports.incrementProgress(file_count, uploaded);
      if (this.status !== 200) {
        bad_responses[bad_responses.length] = this.responseText;
      }
      if (uploaded === file_count) {
        window.merchantos.images.showUploadDone(uploaded, bad_responses);
      }
    };

    if (file_count > 1000) {
      let msg = 'Number of images selected exceeds the 1,000 images ';
      msg += 'per upload limit';
      $('.import-status').show();
      return window.merchantos.images.showUploadError([msg]);
    }

    // Create a form and send it to cloudinary
    function _appendToForm(key: TSFixMe, val: TSFixMe) {
      formData.append(key, val);
    }

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < file_count; index++) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      const file = field.files[index];
      if (file.size > max_size * 1024 * 1024) {
        let message = file.name;
        message += ` is larger than the max size of ${max_size}MB`;
        bad_responses[bad_responses.length] = message;
        uploaded += 1;
        if (file_count > 1 && file_count !== uploaded) {
          // eslint-disable-next-line no-continue
          continue;
        } else {
          $('.import-status').show();
          return window.merchantos.images.showUploadDone(uploaded, bad_responses);
        }
      }
      // Create a new request
      const xhr = new XMLHttpRequest();
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      xhr.open('POST', url);
      xhr.onload = process_finished_request;
      xhr.onerror = process_finished_request;

      // Set the metadata
      let data = field.getAttribute('data-form-data');
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      data = JSON.parse(data);
      $.each(data, _appendToForm);
      // Set the file
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      formData.append('file', field.files[index]);
      xhr.send(formData);
    }
    window.merchantos.items.uploadStart();
  };

  showFileInfo = (file_count: number) => {
    const status_box = $('.import-status');

    status_box.empty();
    status_box.append(window.merchantos.imports.getCancelButton());

    const head = $('<h2>');
    const image = file_count === 1 ? ' image' : ' images';
    head.text(`You selected ${file_count}${image} to upload`);
    status_box.append(head);

    const p1 = $('<p>').text(
      'Once images are uploaded you can attach them to ' +
        'products by specifying the image file name in the image column of a ' +
        'product import.'
    );
    const p2 = $('<p>').text(
      "Anytime an imported product's image file name is" +
        ' matched to an uploaded image it will be automatically attached to ' +
        'that product. Existing image attachments will not be affected.'
    );
    status_box.append(p1);
    status_box.append(p2);
    status_box.show();
  };

  showUploadDone = (uploaded: number, error_array: string[]) => {
    const status_box = $('.import-status');
    status_box.empty();
    let message = '';
    if (error_array.length !== uploaded) {
      const success = uploaded - error_array.length;
      if (success > 1) {
        message += `<strong><var>${success}</var> Images have been uploaded</strong><br>`;
      } else {
        message += '<strong> An Image has been uploaded</strong><br>';
      }
    }
    if (error_array.length) {
      message +=
        '<strong class="import-failure-errors">There was an error with your uploads</strong><br>';
      message += `${error_array.join('<br>')}<br>`;
    }
    message +=
      '<a href="/?name=image.listings.unassigned_images&form_name=listing">View uploaded images</a>-or-';
    message += '<a id="anotherUpload" href="#">Upload more images</a>';
    status_box.append(message);
    $('#anotherUpload').one('click', (event) => {
      event.preventDefault();
      status_box.hide();
      status_box.empty();
      window.merchantos.imports.importClearInput();
    });
  };

  // This function is used when there's an error before we even attempt to upload
  // a single image
  showUploadError = (error_array: string[]) => {
    const $status_box = $('.import-status');
    $status_box.empty();

    let message = '';
    if (error_array.length) {
      message += '<strong class="import-failure-errors">';
      message += 'Your images could not be uploaded</strong><br>';
      message += `${error_array.join('<br>')}<br>`;
    }

    message += '<a id="anotherUpload" href="#">Try again</a>';
    $status_box.append(message);

    $('#anotherUpload').one('click', (event) => {
      event.preventDefault();
      $status_box.hide();
      $status_box.empty();
      window.merchantos.imports.importClearInput();
    });
  };
}

// @ts-expect-error ts-migrate(2322) FIXME: Type 'Imports' is not assignable to type 'Merchant... Remove this comment to see the full error message
window.merchantos.imports = new Imports();
window.merchantos.purchase = new Purchase();
window.merchantos.items = new Items();
window.merchantos.images = new Images();

$(() =>
  $('label#product-import').on('click', (e) => {
    const validator = $('#options-validator');
    if (!window.merchantos.imports.itemImportOptionsValidator(validator)) {
      e.preventDefault();
    }
  })
);
